import { Action, Dispatch } from 'redux';
import { searchAssets } from '../../../api/vault/searchEngine/api';
import { ISearchParams, AssetHit } from '../../../api/vault/searchEngine/interfaces';
import { IAppState } from '../../../state/reducers';
import { Search } from '../../../constants/search';

export type PrePostRoll = 'Pre' | 'Post';
interface IRollTypes {
  PRE: PrePostRoll;
  POST: PrePostRoll;
}
export const ROLL: IRollTypes = {
  PRE: 'Pre',
  POST: 'Post',
};

export interface IState {
  isOpen: boolean,
  selectionType: PrePostRoll | null,
  list: AssetHit[],
}

export enum ActionType {
  OpenPrePostRollSelection = 'PrePostRollSelection.Open',
  ClosePrePostRollSelection = 'PrePostRollSelection.Close',
  SetPrePostRollList = 'PrePostRollSelection.SetRollList',
  ClearPrePostRollSelection = 'PrePostRollSelection.Clear',
}
export interface IPrePostRollSelectionAction extends Action<ActionType> {
  payload: any;
}

const INITIAL_STATE: IState = {
  isOpen: false,
  selectionType: null,
  list: null,
};

export default function reducer(state: IState = INITIAL_STATE, action: IPrePostRollSelectionAction): IState {
  switch (action.type) {
    case ActionType.OpenPrePostRollSelection:
      return {
        ...state,
        isOpen: true,
        selectionType: action.payload,
      };
    case ActionType.ClosePrePostRollSelection:
      return {
        ...state,
        isOpen: false,
      };
    case ActionType.ClearPrePostRollSelection:
      return {
        ...state,
        list: INITIAL_STATE.list,
        selectionType: INITIAL_STATE.selectionType,
      };
    case ActionType.SetPrePostRollList:
      return {
        ...state,
        list: action.payload,
      };
    default:
      return state;
  }
}

export const setPrePostRollList = (list: AssetHit[]) => ({
  type: ActionType.SetPrePostRollList,
  payload: list,
});

export const openPrePostRollSelection = (type: PrePostRoll) => async (
  dispatch: Dispatch<IPrePostRollSelectionAction>,
  getState: () => IAppState,
) => {
  const searchParams: ISearchParams = {
    queryString: '',
    size: Search.DEFAULT_RESULTS_LIMIT_SIZE,
    page: Search.DEFAULT_PAGE,
    filters: [['videoType', [`${type}-Roll`]]],
  };

  const state = getState();

  const response = await searchAssets(searchParams, state.user.impersonation.user);

  dispatch(setPrePostRollList(response.data.data.hits.hits));
  dispatch({
    type: ActionType.OpenPrePostRollSelection,
    payload: type,
  });
};

export const isPrePostRollOpen = () => (
  dispatch: Dispatch<IPrePostRollSelectionAction>,
  getState: () => IAppState,
) => getState().prePostRollSelection.isOpen;

export const closePrePostRollSelection = () => ({
  type: ActionType.ClosePrePostRollSelection,
});

export const clearPrePostRollSelection = () => ({
  type: ActionType.ClearPrePostRollSelection,
});
